import { TreeViewBaseItem } from "@mui/x-tree-view-pro";

/**
 * Recursively extract IDs from a tree structure
 * @param tree The tree structure to process
 * @returns Array of all node IDs in the tree
 */
export const extractNodeIds = <T extends TreeViewBaseItem>(tree: T[]): string[] => {
  let ids: string[] = [];

  for (const node of tree) {
    // Add current node ID
    if (node.id) {
      ids.push(node.id);
    }

    // Process children recursively if they exist
    if (node.children && node.children.length > 0) {
      ids = [...ids, ...extractNodeIds(node.children)];
    }
  }

  return ids;
};
